class CarverallEmailSignUpPopup extends ModalDialog {
  constructor() {
    super();
    this.storageKey = 'cv-email-signup-popup-dismissed';
    this.hasOpened = false;
    this.moved = true;
    this.isDesignMode = this.dataset.designMode === 'true';
    this.onScroll = this.onScroll.bind(this);
    this.onExitIntent = this.onExitIntent.bind(this);
    this.onSectionSelect = this.onSectionSelect.bind(this);
    this.onSectionDeselect = this.onSectionDeselect.bind(this);
    this.initialize();
  }

  initialize() {
    this.attachCopyButton();

    if (this.querySelector('[data-popup-success]')) {
      this.openPopup();
      return;
    }

    if (this.isDesignMode) {
      document.addEventListener('shopify:section:select', this.onSectionSelect);
      document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
      return;
    }

    if (this.isSuppressed()) return;

    const mode = this.dataset.triggerMode || 'delay_or_scroll';
    const delay = Number.parseInt(this.dataset.delayTime, 10) || 15000;

    if (mode === 'delay' || mode === 'delay_or_scroll') {
      this.delayTimer = window.setTimeout(() => this.openPopup(), delay);
    }

    if (mode === 'scroll' || mode === 'delay_or_scroll') {
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    if (this.dataset.exitIntent === 'true' && window.matchMedia('(min-width: 990px)').matches) {
      this.exitIntentTimer = window.setTimeout(() => {
        document.addEventListener('mouseout', this.onExitIntent);
      }, 3000);
    }
  }

  disconnectedCallback() {
    this.removeTriggers();
    document.removeEventListener('shopify:section:select', this.onSectionSelect);
    document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
    document.body.classList.remove('cv-email-popup-is-open');
  }

  onSectionSelect(event) {
    if (!this.isDesignMode) return;
    if (event.target && event.target.contains(this)) {
      this.openPopup(true);
    }
  }

  onSectionDeselect(event) {
    if (!this.isDesignMode) return;
    if (event.target && event.target.contains(this)) {
      this.closeEditorPreview();
    }
  }

  onScroll() {
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (documentHeight <= 0) return;

    const progress = (window.scrollY / documentHeight) * 100;
    const threshold = Number.parseInt(this.dataset.scrollPercent, 10) || 35;
    if (progress >= threshold) this.openPopup();
  }

  onExitIntent(event) {
    if (event.clientY <= 0 && !event.relatedTarget) this.openPopup();
  }

  openPopup(force = false) {
    if (!force && (this.hasOpened || this.hasAttribute('open'))) return;
    if (force && this.hasAttribute('open')) return;

    if (!force) {
      this.hasOpened = true;
      this.removeTriggers();
    }

    document.body.classList.add('cv-email-popup-is-open');
    this.show();
  }

  closeEditorPreview() {
    if (!this.hasAttribute('open')) return;
    document.body.classList.remove('cv-email-popup-is-open');
    super.hide();
  }

  hide() {
    if (this.isDesignMode) {
      this.closeEditorPreview();
      return;
    }

    this.suppress();
    document.body.classList.remove('cv-email-popup-is-open');
    super.hide();
  }

  removeTriggers() {
    window.clearTimeout(this.delayTimer);
    window.clearTimeout(this.exitIntentTimer);
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('mouseout', this.onExitIntent);
  }

  isSuppressed() {
    try {
      const storedValue = window.localStorage.getItem(this.storageKey);
      if (!storedValue) return false;
      return Date.parse(storedValue) > Date.now();
    } catch (error) {
      return false;
    }
  }

  suppress() {
    const days = Number.parseInt(this.dataset.expirationTime, 10) || 7;
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);

    try {
      window.localStorage.setItem(this.storageKey, expirationDate.toISOString());
    } catch (error) {
      return;
    }
  }

  attachCopyButton() {
    const copyButton = this.querySelector('[data-copy-discount]');
    const code = this.querySelector('[data-discount-code]');
    if (!copyButton || !code) return;

    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(code.textContent.trim());
        copyButton.textContent = copyButton.dataset.successLabel;
        window.setTimeout(() => {
          copyButton.textContent = copyButton.dataset.defaultLabel;
        }, 1800);
      } catch (error) {
        const range = document.createRange();
        range.selectNodeContents(code);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });
  }
}

if (!customElements.get('cv-email-signup-popup')) {
  customElements.define('cv-email-signup-popup', CarverallEmailSignUpPopup);
}
